import { useEffect } from 'react';
import { track } from '../lib/analytics';
import { PAGE_NAME } from '../lib/analytics-events';

// Single job: emit screen_viewed for the visible page (PostHog client spec §4 step 6).
// `enabled` is false while the auth screen shows, so nothing is emitted behind it; the
// false -> true transition emits the current screen once.
export function useScreenTracking(page, enabled) {
  useEffect(() => {
    if (!enabled) return;
    track('screen_viewed', { screen: PAGE_NAME[page] ?? 'other' });
  }, [page, enabled]);
}
